import {
  ChangeDetectorRef,
  Component,
  Input,
  SimpleChanges,
} from '@angular/core';
import { Chart } from 'chart.js/auto';
import { IGenericServiceResponse } from '../../../../interfaces/IServiceResponse';
import { environment } from '../../../../../environments/environment';
import { IDashboardChart } from '../../../../interfaces/Dashboard/IDashboardChart';
import { HttpClient } from '@angular/common/http';
import { IDateTimeRange } from 'src/app/interfaces/Dashboard/IDateTimeRange';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
    selector: 'app-dashboard-registration-history-month',
    templateUrl: './dashboard-registration-history-month.component.html',
    styleUrls: ['./dashboard-registration-history-month.component.css'],
    standalone: false
})
export class DashboardRegistrationHistoryMonthComponent {
  @Input() dateTimeRange: IDateTimeRange | null = null; // Input to receive the selected date range

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private readonly dashboardService: DashboardService,
    private cdr: ChangeDetectorRef
  ) {}

  public registrationHistoryMonth: IDashboardChart | null = null;

  ngAfterViewInit(): void {
    this.fetchData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dateTimeRange'] && !changes['dateTimeRange'].firstChange) {
      this.fetchData(); // Fetch data whenever dateTimeRange changes
    }
  }

  BarChart(): void {
    const labels = this.registrationHistoryMonth?.labels || [];
    const datasets = this.registrationHistoryMonth?.dataSet || [];

    const data = {
      labels: labels,
      datasets: datasets.map((dataset, index) => ({
        label: this.translate.instant(dataset.label || ''),
        data: dataset.data,
        backgroundColor: [dataset.backgroundColor],
        borderColor: [dataset.backgroundColor],
        borderWidth: 1,
      })),
    };

    new Chart('registrationHistoryMonth', {
      type: 'bar',
      data: data,
      options: {
        indexAxis: 'x',
        elements: {
          bar: {
            borderWidth: 1,
            borderRadius: 10,
          },
        },
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: this.translate.instant('Admissions Status by Month'),
          },
        },
      },
    });
  }

  fetchData(): void {
    let chartStatus = Chart.getChart('registrationHistoryMonth');
    if (chartStatus != undefined) {
      chartStatus.destroy();
    }

    this.dashboardService
      .getRegistrationHistoryMonth(this.dateTimeRange)
      .subscribe((data) => {
        this.registrationHistoryMonth = data.data;
        this.cdr.detectChanges();
        if (this.registrationHistoryMonth) {
          this.BarChart();
        }
      });
  }
}
